import React from 'react';
import {Popover, List, ListItem, ListItemIcon, ListItemText, Checkbox, Divider, Radio} from '@material-ui/core';
import {Button} from 'components/core';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    button: {
        backgroundColor: theme.palette.background.paper,
        border: `2px solid ${theme.palette.text.primary}`,
        color: theme.palette.text.secondary,
        borderRadius: 20,
        transition: theme.transitions.create(['border-radius'], {
            duration: theme.transitions.duration.standard,
        }),
        '&.selected':
        {
            borderColor: theme.palette.primary.main,
            borderRadius: '20px 20px 0 0'
        }
    },
    popover: {
      minWidth: 280,
      borderTopRightRadius: 0
    },
    footer: {
        padding: '16px 20px',
        height: 72,
        display: 'flex',
        justifyContent: 'space-around',
        '& > *':
        {
            marginLeft: 4,
            marginRight: 4
        }
    },
    list: {
        maxHeight: 400,
        padding:0,
        overflowY: 'auto'
    }
  }), "RaymanFilterMenu");

export default function FilterButton({items = [], onChange = () => {}, label = "", type="check", selectedIndexes = [], disabled = false, ...props})
{
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [checked, setChecked] = React.useState(selectedIndexes);
    const [confirmed, setConfirmed] = React.useState(selectedIndexes);

    function close()
    {
        setAnchorEl(null);
    }

    React.useEffect(function RaiseOnChange(){
        let values = confirmed.map((index) => items[index].value !== undefined ? items[index].value : index);
        onChange(values);
    }, [confirmed, onChange, items]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleApply = () => {
    setConfirmed(checked);
    close();
  };

  const handleClear = () => {
    if(checked.length > 0 && type==="check")
    {
        setChecked([]);
        setConfirmed([]);
        close();
    }
    else
    {
        handleClose();
    }
  };

  const handleClose = () => {
    setChecked(confirmed);
    close();
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if(type === "check")
    {
      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
    }
    else if(type === "radio")
    {
      newChecked[0] = value;
    }


    setChecked(newChecked);
  };


    return <><Button className={clsx(classes.button, Boolean(anchorEl) ? 'selected' : null)} onClick={handleClick} color="secondary">
      {type === "radio" && confirmed.length > 0 ? 
        items[ confirmed[0] ].overrideLabel ? items[ confirmed[0] ].overrideLabel : label
      :
        label+(confirmed.length > 0 ? ` (${confirmed.length})` : "")
      }  
  </Button>
  <Popover
    anchorEl={anchorEl}
    anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
    transformOrigin={{
    vertical: 'top',
    horizontal: 'right',
    }}
    open={Boolean(anchorEl)}
    onClose={handleClose}
    PaperProps={{
        className: classes.popover
    }}
  >
      <List className={classes.list}>
      {items.map((item, index) => {
        const labelId = `checkbox-list-label-${item}`;
        return (
          <ListItem key={index} dense button onClick={handleToggle(index)} disabled={disabled}>
            <ListItemIcon>
              { type === "check" ? // checkbox
              <Checkbox
                edge="start"
                checked={checked.indexOf(index) !== -1}
                tabIndex={-1}
                color="primary"
              />
              : // radio button
              <Radio
              edge="start"
              checked={checked[0] === index}
              tabIndex={-1}
              color="primary"
            /> }
            </ListItemIcon>
            <ListItemText id={labelId} primary={item.text ? item.text : item} />
          </ListItem>
        );
      })}
    </List>
    <Divider />
    <div className={classes.footer}>
        <Button color="secondary" onClick={handleClear}>{checked.length > 0 && type==="check" ? "Limpiar" : "Cancelar"}</Button>
        <Button onClick={handleApply}>Aplicar</Button>
    </div>
  </Popover></>
}